import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, Define, SettingState,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class DNS extends BaseFeature {
    constructor() {
        super();
        this.name = 'DNS';
        this.id = 'dns';
        this.fileLinks = [
            // 'dns\\dns.tbs',
            // 'dns\\dns.tbh',
        ];

        const settings = [
            {
                id: 'ENABLED',
                name: 'DNS Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
            {
                id: 'DNS_DEBUG_PRINT',
                name: 'Debug Print',
                settingType: SettingType.HIDDEN,
                required: true,
                helpText: 'Debug print messages',
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getFiles(): string[] {
        if (this.project.runtime === 'tios') {
            return [
                'libraries/dns/dns.tbh',
                'libraries/dns/dns.tbs',
            ];
        }
        return [];
    }

    getDependencies() {
        const dependencies = [
            'sock',
        ];

        return dependencies;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];

        return errors;
    }

    getState(settingId: string): SettingState {
        if (settingId !== 'ENABLED' && this.getSettingValue('ENABLED').toString() === '0') {
            return SettingState.HIDDEN;
        }
        switch (settingId) {
            case 'ENABLED':
                return SettingState.ENABLED;
            default:
                return SettingState.ENABLED;
        }
    }

    getDefines(): Array<Define> {
        const defines = [];
        const DNS_DEBUG_PRINT = this.getSettingValue('DNS_DEBUG_PRINT');
        if (DNS_DEBUG_PRINT === '1') {
            defines.push({
                name: 'DNS_DEBUG_PRINT',
                value: '1',
            });
        }

        return defines;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
